import { useGetMenuHeaderQuery } from '@/features/api/endpoints/LayoutEndpoints';
import { ActionIcon, Tooltip } from '@mantine/core';
import { IconHelp } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';
import { Link } from 'react-router-dom';

const UserHelpBtn = () => {
  const { t } = useTranslate();
  const { data } = useGetMenuHeaderQuery();

  if (!data || data.status_help !== 'published' || !data.helpLink?.trim() || !data.helpType) {
    return null;
  }

  const helpLink = data.helpLink.trim();

  if (data.helpType === 'external_link') {
    return (
      <Tooltip label={t('header.help')} withArrow>
        <ActionIcon
          component="a"
          href={helpLink}
          target="_blank"
          rel="noopener noreferrer"
          variant="subtle"
          color="gray"
          aria-label={t('header.help')}
        >
          <IconHelp />
        </ActionIcon>
      </Tooltip>
    );
  }

  if (data.helpType === 'internal_link') {
    return (
      <Tooltip label={t('header.help')} withArrow>
        <ActionIcon
          component={Link}
          to={helpLink}
          variant="subtle"
          color="gray"
          aria-label={t('header.help')}
        >
          <IconHelp />
        </ActionIcon>
      </Tooltip>
    );
  }

  if (data.helpType === 'iframe') {
    return (
      <Tooltip label={t('header.help')} withArrow>
        <ActionIcon
          component={Link}
          to="/help-page"
          variant="subtle"
          color="gray"
          aria-label={t('header.help')}
        >
          <IconHelp />
        </ActionIcon>
      </Tooltip>
    );
  }

  return null;
};

export default UserHelpBtn;
